/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useContext } from "react";

import "../css/login.css";
import { Container, Button, Row, Col } from "react-bootstrap";
import { AuthContext } from "../contexts/AuthContext";

/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */
const Login = () => {
  const { handleLogin, actualUser } = useContext(AuthContext);

  return (
    <>
      <Container fluid id="login">
        <Row>
          <Col md={{ span: 3, offset: 9 }} className="contentLogin">
            <h1>Faqs</h1>
            {actualUser ? (
              <>
                <p className="help">
                  Hola {actualUser.displayName}, ya estas logueado!
                </p>
                <Button variant="secondary" onClick={() => window.location.href = '/'}>
                  Ir al inicio
                </Button>
              </>
            ) : (
              <>
                <p className="help">
                  Por favor, inicie sesion con las credenciales de Possumus
                </p>
                <Button variant="secondary" onClick={() => handleLogin()}>
                  Iniciar sesión
                </Button>
                <div className="bottom">
                  <p>
                    <span>
                      Este es un dispositivo corporativo perteneciente a
                      Possumus
                    </span>
                  </p>
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
